/* @flow */
import actionTypes from '../actions/types';
import feature from '../config/feature';

export type Curreny = {
  name: string,
  pair: string,
  symbol: string,
  rate?: number,
};

const { fiatSymbol } = feature;

const CURRENY_MAP = [
  { name: 'CNY', symbol: '¥' },
  { name: 'EUR', symbol: '€' },
  { name: 'GBP', symbol: '£' },
  { name: 'JPY', symbol: '¥' },
  { name: 'KRW', symbol: '₩' },
  { name: 'RUB', symbol: '₽' },
  { name: 'USD', symbol: '$' },
  { name: 'INR', symbol: '₹' },
  { name: 'TRY', symbol: '₺' },
  { name: 'CAD', symbol: 'C$' },
  { name: 'IDR', symbol: 'Rp' },
  { name: 'AUD', symbol: 'A$' },
  { name: 'BRL', symbol: 'R$' },
];

export const INITIAL_STATE = {
  cnyUsdRate: 0,
  fiatRate: {},
  currencyList: CURRENY_MAP,
};

const onFetchCurrencySuccess = (data) => CURRENY_MAP.map((c) => {
  const currencyList = [...data, { pair: 'USD_USD', rate: 1 }];
  const pair = `${c.name}_${fiatSymbol}`;
  const pairObj = currencyList.filter(v => v.pair === pair);

  return Object.assign(
    {}, c, {
      pair,
      rate: pairObj.length > 0 ? Number(pairObj[0].rate) : undefined,
    }
  );
});

export const reducer = (state: any, action: any) => {
  switch (action.type) {
    case actionTypes.SET_EXCHANGE_INFO:
      return { ...state, info: action.data };
    case actionTypes.SET_CURRENCY_RATE_DATA:
      return {
        ...state,
        currencyList: onFetchCurrencySuccess(action.data),
      };
    case actionTypes.SET_TO_FIAT_RATE:
      return { ...state, fiatRate: action.data };
    default:
      return state;
  }
};
